<div class="toolbar" role="banner">
    <a routerLink=""><img src="../../../../../assets/images/header/logo-header.png" /></a>
    <div class="spacer-header-logo"></div>
    <img class="phone-header-image" src="../../../../../assets/images/header/tel-header.png" />
    <div class="spacer-header-phone"></div>
    <span class="phone-header">0800 4232</span>
    <div class="spacer"></div>
    <a class="a-header" routerLink="/empresas">Empresas</a>
    <div class="spacer-header"></div>
    <a class="a-header" routerLink="/inefop">Inefop</a>
    <div *ngIf="!activeBeca" class="spacer-header"></div>
    <a *ngIf="!activeBeca" class="a-header" routerLink="/becas">Becas</a>
    <div class="spacer-header"></div>
    <a class="a-header" routerLink="/careers">Trabaja con nosotros</a>
    <div class="spacer-header"></div>
    <a class="a-header" routerLink="/franquicias">Franquicias</a>
    <div class="spacer-header"></div>
    <input class="buscador" (ngModelChange)="onSearch()"  [(ngModel)]="search" onfocus="this.className='buscador-focus'" onblur="this.className='buscador-focus'" name="buscador"/>
  <div class="responsive-toolbar-social row">
    <a class="a-social" href="https://www.instagram.com/ibec_internacional/" target="_blank"><img class="social-header" src="../../../../../assets/images/iconos/instagram-responsive.png" /></a>
    <div class="spacer-social"></div>
    <a class="a-social" href="https://www.facebook.com/IbecInternacional" target="_blank"><img class="social-header" src="../../../../../assets/images/iconos/facebook-responsive.png" /></a>
    <div class="spacer-social"></div>
    <a class="a-social" href="https://www.youtube.com/user/aycdigital" target="_blank"><img class="social-header" src="../../../../../assets/images/iconos/youtube-responsive.png" /></a>
    <div class="spacer-social"></div>
    <a class="a-social" href="https://www.linkedin.com/school/institutoibec/" target="_blank"><img class="social-header" src="../../../../../assets/images/iconos/linkedin-responsive.png" /></a>
  </div>
</div>
<div class="toolbar-down-responsive">
  <app-hamburger-menu></app-hamburger-menu>
</div>
<div class="toolbar-down">
  <div class="toolbar-menu">

    <a class="a-menu" routerLink="">INICIO</a>
    <div class="spacer-menu"></div>
    <a class="a-menu" routerLink="/instituto">INSTITUTO</a>
    <div class="spacer-menu"></div>


    <a class="a-menu" style="cursor: default;" [matMenuTriggerFor] = "menu">CARRERAS Y CURSOS<img class="down-arrow" src="../../../../../assets/images/header/down-arrow.png" /></a>
    <mat-menu  #menu = "matMenu">
      <div class="div-menu-escuelas">
        <a routerLink="/arquitectura-y-visualizacion" class="a-menu-escuelas">
          <div class="rejilla-menu">
            <div class="rejilla-menu-centrar"><img src="../../../../../assets/images/header/icono-arq-submenu.png" /></div>
            <div class="rejilla-menu-centrar">Arquitectura y Visualización</div>
          </div>
        </a>
      </div>
      <div class="div-menu-escuelas">
      <a routerLink="/diseno-y-comunicacion" class="a-menu-escuelas">
        <div class="rejilla-menu">
          <div class="rejilla-menu-centrar"><img src="../../../../../assets/images/header/icono-com-visual-submenu.png" /></div>
          <div class="rejilla-menu-centrar">Diseño y Comunicación</div>
        </div>
      </a>
      </div>
      <div class="div-menu-escuelas">
        <a routerLink="/marketing-negocios-y-administracion" class="a-menu-escuelas">
          <div class="rejilla-menu">
            <div class="rejilla-menu-centrar"><img src="../../../../../assets/images/header/icono-marketing-submenu.png" /></div>
            <div class="rejilla-menu-centrar">Marketing, Negocios y Administración</div>
          </div>
        </a>
      </div>
      <div class="div-menu-escuelas">
        <a routerLink="/sistemas-y-tecnologias" class="a-menu-escuelas">
          <div class="rejilla-menu">
            <div class="rejilla-menu-centrar"><img src="../../../../../assets/images/header/icono-tecnologia-submenu.png" /></div>
            <div class="rejilla-menu-centrar">Sistemas y Tecnologías</div>
          </div>
        </a>
      </div>
    </mat-menu>

   <!-- <div class="spacer-menu"></div>
    <a class="a-menu" routerLink="/postgrados">POSTGRADOS</a>-->
    <div class="spacer-menu"></div>
    <a class="a-menu" routerLink="/alumnos">ALUMNOS</a>
    <div class="spacer-menu"></div>
    <a class="a-menu" routerLink="/docentes">DOCENTES</a>
    <div class="spacer-menu"></div>
    <a class="a-menu" routerLink="/contacto">CONTACTO</a>
    <div class="spacer-sede"></div>
    <p class="text-sede" href=""><strong>Sede Central:</strong> Bvar. España 2497 | MVD | UY</p>
    <div class="spacer-header-logo"></div>
    <a class="a-social" href="https://www.instagram.com/ibec_internacional/" target="_blank"><img class="social-header" src="../../../../../assets/images/header/instagram-header.png" /></a>
    <div class="spacer-social"></div>
    <a class="a-social" href="https://www.facebook.com/IbecInternacional" target="_blank"><img class="social-header" src="../../../../../assets/images/header/facebook-header.png" /></a>
    <div class="spacer-social"></div>
    <a class="a-social" href="https://www.youtube.com/user/aycdigital" target="_blank"><img class="social-header" src="../../../../../assets/images/header/youtube-header.png" /></a>
    <div class="spacer-social"></div>
    <a class="a-social" href="https://www.linkedin.com/school/institutoibec/" target="_blank"><img class="social-header" src="../../../../../assets/images/header/in-header.png" /></a>
  </div>
<div>
<div class="div-externo">
  <div class="rejilla">
    <div>
      <a href="tel:08004232">
        <img class="side-menu" src="../../../../../assets/images/iconos/tel-fijos.png" />
      </a>
    </div>
    <div>
      <a href="https://api.whatsapp.com/send?phone=59897423232" target="_blank">
      <img class="side-menu" src="../../../../../assets/images/iconos/wapp-fijos.png" />
      </a>
    </div>
    <div>
      <a href="mailto:info@ibec.edu.uy">
        <img class="side-menu" src="../../../../../assets/images/iconos/mail-fijos.png" />
      </a>
    </div>
<!--    <div>-->
<!--      <a href="https://tawk.to/chat/578695deaea970641176e961/default" target="_blank">-->
<!--        <img class="side-menu" src="../../../../../assets/images/iconos/chat-fijos.png" />-->
<!--      </a>-->
<!--    </div>-->
  </div>
</div>



